import { hostTypeSelector } from '../../selectors/hostTypeSelector';
import { unreadMessagesCountSelector } from '../../selectors/unreadMessagesCountSelector';
import { userSelector } from '../../selectors/userSelector';
import { EHostType } from '../../types/hostType';
import { TThunkAction, TThunkDispatch } from '../../types/redux/thunk';
import { BlinkingTitleSingleton } from '../../utils/BlinkingTitleSingleton/BlinkingTitleSingleton';

interface ISetBlinkingTitleProps {
  isWindowFocused: boolean;
}

/**
 * Управляет отображением мигающего заголовка
 */
export const setBlinkingTitle =
  ({ isWindowFocused }: ISetBlinkingTitleProps): TThunkAction<Promise<void>> =>
  async (_dispatch, getState) => {
    const state = getState();

    const hostType = hostTypeSelector(state);
    const isIframe = hostType === EHostType.Frame;

    const { isAuthenticated } = userSelector(state);

    const unreadMessagesCount = unreadMessagesCountSelector(state);

    const blinkingTitle = BlinkingTitleSingleton.getInstance();

    if (isWindowFocused || isIframe || !isAuthenticated) {
      blinkingTitle.resetDocumentInfo();

      return;
    }

    if (unreadMessagesCount) {
      blinkingTitle.setBlinkingDocumentInfo(unreadMessagesCount);
    } else {
      blinkingTitle.resetDocumentInfo();
    }
  };

let timeout: ReturnType<typeof setTimeout>;

const BLINKING_TITLE_TIMEOUT = 3000;

export const setBlinkingTitleWithTimeout =
  ({ isWindowFocused }: ISetBlinkingTitleProps) =>
  (dispatch: TThunkDispatch) => {
    if (!isWindowFocused) {
      const timeoutOn = () => {
        clearTimeout(timeout);
        dispatch(setBlinkingTitle({ isWindowFocused }));
        timeout = setTimeout(timeoutOn, BLINKING_TITLE_TIMEOUT);
      };
      timeoutOn();
    } else {
      clearTimeout(timeout);
      dispatch(setBlinkingTitle({ isWindowFocused }));
    }
  };
